import { CREATE_POST_STREAM, CREATE_STREAM } from "../actions/types";

const initialStreamState = {
    playbackUrl: "",
    streamKey: "",
    post:null,
}

export default function (state = initialStreamState, action) { 
    switch (action.type) {
        case CREATE_STREAM:
            return action.payload
            case CREATE_POST_STREAM:
            return {...state,post:action.payload}  
        default:
            return state
    }

}